import { render, staticRenderFns } from "./deils.vue?vue&type=template&id=c04596ba&scoped=true"
import script from "./deils.vue?vue&type=script&lang=js"
export * from "./deils.vue?vue&type=script&lang=js"
import style0 from "./deils.vue?vue&type=style&index=0&id=c04596ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04596ba",
  null
  
)

export default component.exports